export const environment = {
    production: false,
    hmr: false,
    dynamicTheme: true,
    appConfig: 'appconfig.staging.json',
};
